export const apiVersion = process.env.SANITY_STUDIO_API_VERSION || "2025-06-11";

export const datasetProduction = "production";

export const datasetDevelopment = "development";

export const projectId = "4bgok82s";

export type Dataset = typeof datasetProduction | typeof datasetDevelopment;

// True when querying the production Sanity dataset. A Vercel preview build has
// NODE_ENV="production" but reads the development dataset, so both are checked.
// Single source of truth shared by client.ts and build-time dataset assertions.
export const isProductionDataset = (): boolean =>
  process.env.NODE_ENV === "production" &&
  process.env.NEXT_PUBLIC_VERCEL_ENV !== "preview";

// Resolves the dataset to query. Accepts an explicit override via
// NEXT_PUBLIC_SANITY_DATASET_OVERRIDE (required for the Publisher sandbox, which
// runs `next dev` and so always has NODE_ENV=development). Throws on any
// unrecognised non-empty value to prevent silent typo-driven dataset mismatches.
export const resolveDataset = (): Dataset => {
  const override = process.env.NEXT_PUBLIC_SANITY_DATASET_OVERRIDE;
  if (override) {
    if (override !== datasetProduction && override !== datasetDevelopment) {
      throw new Error(
        `Invalid NEXT_PUBLIC_SANITY_DATASET_OVERRIDE: ${override}`,
      );
    }
    return override;
  }
  return isProductionDataset() ? datasetProduction : datasetDevelopment;
};
